import jwt_decode from 'jwt-decode';

const getLocalRefreshToken = () => {
  const tokens = JSON.parse(localStorage.getItem('tokens') || '{}');
  return tokens?.refresh;
};

const getLocalAccessToken = () => {
  const tokens = JSON.parse(localStorage.getItem('tokens') || '{}');
  return tokens?.access;
};

const updateLocalAccessToken = (token: { access: string; refresh: string }) => {
  const tokens = JSON.parse(localStorage.getItem('tokens') || '{}');
  tokens.access = token;
  localStorage.setItem('tokens', JSON.stringify(tokens));
};

const getToken = () => {
  return JSON.parse(localStorage.getItem('tokens') || '{}');
};

const setToken = (token: { access: string; refresh: string }) => {
  localStorage.setItem('tokens', JSON.stringify(token));
};

const getDataFromJwtToken = (token: { access: string }) => {
  if (!token) {
    return {};
  }

  const { sub, uuid, role }: { sub: string; uuid: string; role: string } = jwt_decode(
    token?.access
  );

  return {
    sub: sub,
    uuid: uuid,
    role: role
  };
};

const removeUser = async () => {
  localStorage.removeItem('tokens');
};

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  getToken,
  setToken,
  getDataFromJwtToken,
  removeUser
};

export default TokenService;
